import {
  calculateTotalHours,
  formatDateForDisplay,
  formatDateToDMY,
  getDayFromDate,
} from "@/lib/utils";
import {
  format,
  isThisWeek,
  isToday,
  isYesterday,
  startOfWeek,
} from "date-fns";

export const DAYS_TO_SHOW = 8;

/**
 * Transforms raw timesheet data into a structure optimized for UI display
 * @param {Array} rawTimesheetData - Raw data from the API
 * @param {Array} capacityData - Daily work capacity data
 * @returns {Object} Structured data ready for UI consumption
 */
export function transformProjectDailyTimesheetData(
  rawDailyTimesheetData,
  date
) {
  const entries = rawDailyTimesheetData;

  const dailyLoggedTotal = calculateTotalHours(entries, "logged_hours");
  const dailyApprovedTotal = calculateTotalHours(entries, "approved_hours");
  const dailyUnApprovedTotal = calculateTotalHours(entries, "unapproved_hours");

  // Extract capacity info from capacityData (assuming it's an array with one item for the day)

  return {
    date: date,
    formattedDate: formatDateForDisplay(date),
    day: getDayFromDate(date),
    entries: entries.filter(
      (entry) =>
        entry.logged_hours &&
        entry.approved_hours + entry.unapproved_hours !== entry.logged_hours
    ),
    dailyLoggedTotal,
    dailyApprovedTotal,
    dailyUnApprovedTotal,
    isRevieweComplete:
      dailyLoggedTotal > 0 &&
      dailyApprovedTotal + dailyUnApprovedTotal === dailyLoggedTotal,
  };
}

export function formatDateForTimesheet(date) {
  if (isToday(date)) {
    return "Today";
  }

  if (isYesterday(date)) {
    return "Yesterday";
  }

  if (isThisWeek(date, { weekStartsOn: 1 })) {
    // Format as weekday (e.g., 'Monday')
    return format(date, "EEEE");
  }

  // Fallback to dd/MM/yyyy
  return formatDateToDMY(date);
}
